/* eslint-disable */
export default {
  title: '履歴',
} as const;

// @key: @#@"title"@#@ @source: @#@"History"@#@
